import { Product as i } from "cerulean/dist/lib/product";
import { Product as C } from "cerulean/dist/lib/product";
import { isInOneNav as e } from "../onenav/is-in-onenav.js";
const a = /^\/(?:analytics|audiences|data|experiment)\/([^/]+)/, c = /^\/amp-dev-docs\/(.+)/, m = /^\/([^/]+)/, w = () => {
  let t = /^\/org\/(\d+)/;
  e() && (t = /^\/(?:analytics|audiences|data|experiment)\/org\/(\d+)/);
  const n = window.location.pathname.match(t);
  return (n == null ? void 0 : n[1]) || null;
}, p = (t) => {
  const n = t.match(/\/space\/([^/]+)/);
  return (n == null ? void 0 : n[1]) || null;
}, h = (t) => {
  const n = t.match(/\/space\/[^/]+\/([^/?]+)/);
  return (n == null ? void 0 : n[1]) || null;
}, u = [
  "org",
  "share",
  "subscriptions",
  "iframe",
  "external-embed"
], g = () => {
  const t = e() ? a : m, n = window.location.pathname.match(t), r = (n == null ? void 0 : n[1].toLowerCase()) || null;
  return r && u.includes(r) ? null : r;
}, f = () => {
  const t = e() ? a : c, n = window.location.pathname.match(t);
  return (n == null ? void 0 : n[1]) ?? null;
}, P = () => e() ? /^(?:\/analytics)?\/iframe\//.test(window.location.pathname) : /^\/iframe\//.test(window.location.pathname), _ = () => e() ? /^(?:\/analytics)?\/share\/\w+/.test(window.location.pathname) : /^\/share\/\w+/.test(window.location.pathname), b = () => e() ? /^(?:\/analytics)?\/subscriptions\/unsubscribe\/\w+/.test(
  window.location.pathname
) : /^\/subscriptions\/unsubscribe\/\w+/.test(window.location.pathname), x = () => e() ? /^(?:\/analytics)?\/external-embed\/?/.test(
  window.location.pathname
) : /^\/external-embed\/?/.test(window.location.pathname), L = () => {
  const t = window.location.pathname.match(
    /^\/(analytics|audiences|data|experiment)/
  );
  return t != null && t[1] ? t[1] : i.ANALYTICS;
}, U = (t) => e() && t.match(a) ? t.replace(/^\/(analytics|audiences|data|experiment)/, "") : t, E = () => window.__CURRENTAPP__, O = () => window.__CURRENTAPP__, R = (t) => typeof t == "string" ? t : "pathname" in t && t.pathname ? t.pathname : "", S = (t, n) => {
  const r = new URLSearchParams(t.search);
  return n.forEach((o, s) => {
    r.set(s, o);
  }), {
    ...t,
    search: r.toString()
  };
};
export {
  a as ONE_NAV_SUBDOMAIN_RE,
  C as TempProduct,
  S as forwardAllSearchParamsToLocation,
  U as getCurrentPathname,
  E as getCurrentProduct,
  L as getCurrentProductFromUrl,
  p as getHubIdFromPathname,
  h as getHubTabIdFromPathname,
  w as getOrgIdFromLocation,
  g as getOrgUrlFromLocation,
  f as getPathFromLocation,
  R as getPathStringFromLocation,
  x as isExternalEmbedLocation,
  P as isIframeLocation,
  _ as isShareLocation,
  b as isUnsubscribeLocation,
  O as tempGetCurrentProduct
};
//# sourceMappingURL=location.js.map
